// extracted by css-extract-rspack-plugin
export default {"leadsbutton-content":"LeadsButton-module__leadsbutton-content--WIPWp","leadsbuttonContent":"LeadsButton-module__leadsbutton-content--WIPWp"};